import { Component, OnInit, OnDestroy, Input, inject } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';

import { Alert, AlertType } from '@mavles/shared';
import { AlertService } from '@mavles/shared';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    standalone: false
})
export class AlertComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private alertService = inject(AlertService);

  @Input() id = 'default-alert';
  @Input() fade = true;

  alerts: Alert[] = [];
  private alertSubscription: Subscription | undefined;
  private routeSubscription: Subscription | undefined;

  ngOnInit() {
    this.alertSubscription = this.alertService.onAlert(this.id)
      .subscribe(alert => {
        if (!alert.message) {
          this.alerts = this.alerts.filter(x => x.keepAfterRouteChange);
          this.alerts.forEach(x => x.keepAfterRouteChange = false);
          return;
        }

        this.alerts.push(alert);

        if (alert.autoClose) {
          //setTimeout(() => this.removeAlert(alert), 3000);
        }
      });

    this.routeSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.alertService.clear(this.id);
      }
    });
  }

  ngOnDestroy() {
    this.alertSubscription?.unsubscribe();
    this.routeSubscription?.unsubscribe();
  }

  removeAlert(alert: Alert) {
    if (!this.alerts.includes(alert)) return;

    if (this.fade) {
      alert.fade = true;
      setTimeout(() => {
        this.alerts = this.alerts.filter(x => x !== alert);
      }, 250);
    } else {
      this.alerts = this.alerts.filter(x => x !== alert);
    }
  }

    cssClass(alert: Alert) {
        if (!alert) return '';

        const baseClasses = ['alert', 'alert-dismissible'];
        const alertTypeClass = this.getAlertTypeClass(alert.type);
        const fadeClass = alert.fade ? 'fade' : '';

        return [...baseClasses, alertTypeClass, fadeClass].filter(Boolean).join(' ');
    }

    private getAlertTypeClass(type?: AlertType): string {
        const alertTypeClass = {
            [AlertType.Success]: 'alert-success',
            [AlertType.Error]: 'alert-danger',
            [AlertType.Info]: 'alert-info',
            [AlertType.Warning]: 'alert-warning'
        };
        return type ? alertTypeClass[type] : '';
    }

}


